import "../App.css";
import EditDoctorInfo from "./EditDoctorInfo";
import { Doctor } from "./interfaces";

const DoctorSheet = () => {
  return (
    <>
      <div className="container">
        <h3 className="section-title">Aggiorna le tue informazioni</h3>
      </div>
      <EditDoctorInfo />
    </>
  );
};

export default DoctorSheet;
